import { QueryClientProvider } from "@tanstack/react-query";
import { Suspense, lazy, type ComponentPropsWithoutRef } from "react";
import { Toaster } from "react-hot-toast";
import { queryClient } from "../../query";

const ManageAPITokensInner = lazy(() => import("./component"));

export default function ManageAPITokens(
  props: ComponentPropsWithoutRef<typeof ManageAPITokensInner>
) {
  return (
    <QueryClientProvider client={queryClient}>
      <Suspense>
        <ManageAPITokensInner {...props} />
      </Suspense>
      <Toaster />
    </QueryClientProvider>
  );
}
